<template>
  <div
    class="login-mask-layer"
    v-show="MASK_ACTIVE"
    @click.self="closeMask"
    @mousewheel.stop.prevent
  >
    <section class="login-page">
      <div class="login-container">
        <div class="adorn-hr-right">
          <div class="adorn-hr-right-1">
            <div class="login-outer">
              <template v-for="(item, index) in loginType">
                <div
                  class="login-button"
                  :class="`login-button-${item.name}`"
                  :key="`login-button-${index}`"
                  @click="snsLogin(item.name)"
                >
                  <img class="login-icon" :src="item.icon" :alt="item.name" />
                </div>
              </template>
            </div>
          </div>
          <div class="adorn-hr-right-2"></div>
        </div>

        <div class="login-content">
          <img src="../assets/images/login/logo.png" class="logo" alt />
          <div class="login-form">
            <div class="login-input" v-if="NAME_CHILD">
              <div class="login-email-box">
                <input
                  type="email"
                  class="login-email"
                  placeholder="Please enter your email"
                  v-model.trim="yostarEmail"
                />
              </div>
            </div>
            <div class="login-input" v-if="NAME_CHILD">
              <div class="login-code-box">
                <input
                  type="text"
                  placeholder="Enter email verification code"
                  class="login-code"
                  v-model.trim="code"
                />
                <button
                  class="login-code-button"
                  @click="checkoutYostarEmail"
                  v-text="waitShow ? `${waitTime}s` : 'SEND'"
                ></button>
              </div>
            </div>
            <div class="login-input input-nickname" v-if="!NAME_CHILD">
              <div class="login-nickname-box">
                <input
                  type="text"
                  v-model.trim="nickname"
                  placeholder="Input nickname"
                  class="login-nickname"
                />
              </div>
            </div>

            <p class="login-nickname-tip" v-if="!NAME_CHILD">
              *Nickname cannot be changed after confirmation
            </p>
            <div class="yostar-login-box">
              <button class="login-in-button" @click="login">Log in</button>
              <button class="cancel-button" @click="cancelLogin">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "../plugins/bus";
export default {
  name: "LoginMask",

  components: {},
  data: () => ({
    loginType: [
      {
        name: "twitter",
        icon: require("../assets/images/login/twitter_icon.png"),
      },
      {
        name: "facebook",
        icon: require("../assets/images/login/fb_icon.png"),
      },

      {
        name: "apple",
        icon: require("../assets/images/login/apple_icon.png"),
      },
    ],

    newWindow: "",
    loopTimer: null,

    waitShow: false,
    waitTime: 60,
    waitTimer: null,

    yostarEmail: "",
    code: "",
    nickname: "",
  }),
  created() {
  },
  mounted() {
    EventBus.$on("cancelLogin",()=>{
      this.cancelLogin()
    })
  },
  watch: {
    waitShow(val) {
      if (val) {
        // 开启定时器
        this.waitTimer = setInterval(() => {
          this.waitTime = this.waitTime - 1;
          if (this.waitTime <= 0) {
            // 清除
            clearInterval(this.waitTimer);
            this.waitTimer = null;
            this.waitTime = 60;
            this.waitShow = false;
          }
        }, 1000);
      }
    },
  },
  computed: {
    ...mapState({
      MASK_ACTIVE: (state) => state.LoginMask.MASK_ACTIVE,
      NAME_CHILD: (state) => state.User.NAME_CHILD, //玩家起名
    }),
  },
  methods: {
    closeMask() {
      this.$store.commit("LoginMask/SET_MASK_ACTIVE", false);
      this.yostarEmail = "";
      this.code = "";
    },
    checkoutYostarEmail() {
      if (this.waitShow) {
        return false;
      }
      if (!this.$utils.checkEmail(this.yostarEmail)) {
        return alert("Please enter a correct email address.");
      }

      this.axios
        .post("/user/send-code", {
          account: this.yostarEmail,
        })
        .then((v) => {
          // 成功
          this.waitShow = true;
        });
    },
    login() {
      if (!this.NAME_CHILD) {
        // 取名
        this.axios
          .get("/auth/set-nickname", {
            params: {
              nickname: this.nickname,
            },
          })
          .then((v) => {
            // 成功
            this.$store
              .dispatch("User/getUserInfo")
              .then((v) => {
                this.cancelLogin();
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        // yostar账号登入
        if (!this.$utils.checkEmail(this.yostarEmail) || !this.code) {
          return false;
        }
        this.axios
          .post("/user/yostar", {
            account: this.yostarEmail,
            code: this.code,
          })
          .then((v) => {
            // 成功
            if(v.meta.ok){
              this.axios.post("/user/login",{
                token:v.data.token,
                channel:v.data.channel
              }).then((v)=>{
                window.gtag('event', `complete_logincontest`);
                this.$store
                .dispatch("User/getUserInfo")
                .then((v) => {
                  if (v.data.uid && v.data.nickname) {
                    // 如果已经取名，直接关闭登入弹窗
                    this.cancelLogin();
                  } 
                })
                .catch((e) => {
                  console.log(e);
                });
              }).catch((v)=>{
                
              })
            }
          });
      }
    },
    snsLogin(sns) {
      // 开新窗口
      // console.log('process.env.VUE_APP_HOST',process.env)
      // return
      // this.newWindow = this.$utils.openLogin(sns);
      window.location.href = `https://web-open-azurlane.yo-star.com/api/account/${sns}?redirectUrl=${process.env.VUE_APP_HOST}/contest`

      // 最多循环次数
      // let maxLoopCount = 240;
      // this.loopTimer = setInterval(() => {
      //   maxLoopCount--;
      //   if (this.newWindow.closed) {
      //     // 关闭窗口
      //     console.log("newWindow is closed.");
      //     clearInterval(this.loopTimer);
      //     this.$store
      //       .dispatch("User/getUserInfo")
      //       .then((v) => {
      //         if (v.data.uid && v.data.nickname) {
      //           // 如果已经取名，直接关闭登入弹窗
      //           this.cancelLogin();
      //         } 
      //       })
      //       .catch((e) => {
      //         console.log(e);
      //       });
      //   } else if(maxLoopCount <= 0) {
      //     console.log("loop time out.")
      //     clearInterval(this.loopTimer);
      //   }
      // }, 500);
    },
    cancelLogin() {
      this.$store.commit("LoginMask/SET_MASK_ACTIVE", false);
      this.yostarEmail = "";
      this.code = "";
    },
  },
};

</script>

<style lang="scss" scoped>
.login-mask-layer {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;

  .login-page {
    width: 100%;
    background: url(../assets/images/login/BG.png);
    background-size: cover;
    background-position: center top;
    overflow: hidden;
    width: pxTorem(702px);
    height: pxTorem(402px);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .login-container {
      margin: 0 auto;

      .adorn-hr-right {
        position: absolute;
        right: pxTorem(104px);
        top: pxTorem(35px);

        .adorn-hr-right-1 {
          width: pxTorem(1px);
          height: pxTorem(360px);
          position: relative;
          display: flex;
          flex-direction: column;

          &::before,
          &::after {
            content: "";
            display: block;
            width: 100%;
            background: #a0a0a0;
            flex: 1;
          }

          .login-outer {
            width: pxTorem(50px);
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin: pxTorem(9px) 0;

            .login-button {
              width: 100%;
              height: pxTorem(50px);
              cursor: pointer;

              &:not(:last-of-type) {
                margin-bottom: pxTorem(10px);
              }

              .login-icon {
                display: block;
                width: 100%;
              }

              &.login-button-yostar {
                background: #000;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;

                .login-icon {
                  width: 70%;
                }
              }
            }
          }
        }
        // .adorn-hr-right-2 {
        //   width: pxTorem(5px);
        //   height: pxTorem(96px);
        //   position: absolute;
        //   background: #ffcc00;
        //   top: 100%;
        //   left: 0;
        //   transform: rotate(45deg);
        //   transform-origin: right top;

        //   &::after {
        //     content: "";
        //     display: block;
        //     width: 100%;
        //     height: pxTorem(210px);
        //     background: #ffcc00;
        //     position: absolute;
        //     top: pxTorem(15px);
        //     left: pxTorem(-15px);
        //   }
        // }
      }
      .login-content {
        width: pxTorem(600px);
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .logo {
          margin-top: pxTorem(37px);
          display: block;
          width: pxTorem(128px);
          margin-bottom: pxTorem(18px);
          margin-right: pxTorem(260px);
        }
        .login-form {
          width: pxTorem(360px);

          .login-input {
            width: 100%;
            height: pxTorem(37px);
            border: 1px solid #585858;
            font-size: 0;

            &::after {
              content: "";
              display: block;
              width: 100%;
              height: pxTorem(3px);
              background: #0062d0;
            }
            &:nth-of-type(1),
            &:nth-of-type(2) {
              margin-bottom: pxTorem(25px);
            }
            &.input-nickname {
              margin-top: pxTorem(48px);
              margin-bottom: pxTorem(10px);
            }

            .login-email-box {
              width: 100%;
              height: pxTorem(34px);

              .login-email {
                width: 100%;
                height: 100%;
                @include clearInput;
                color: #000;
                font-size: pxTorem(18px);
                line-height: pxTorem(34px);

                &::placeholder {
                  color: #808081;
                  font-style: italic;
                }
              }
            }
            .login-code-box {
              width: 100%;
              height: pxTorem(34px);
              display: flex;

              .login-code {
                flex: 1;
                @include clearInput;
                color: black;
                font-size: pxTorem(18px);
                line-height: pxTorem(34px);

                &::placeholder {
                  color: #808081;
                  font-style: italic;
                }
              }
              .login-code-button {
                color: white;
                width: pxTorem(100px);
                height: 100%;
                background: #0358e2;
                line-height: pxTorem(34px);
                font-size: pxTorem(20px);
                font-style: italic;
                font-weight: bold;
                font-family: "Noto Sans KR", sans-serif;
                cursor: pointer;
              }
            }
            .login-nickname-box {
              width: 100%;
              height: pxTorem(34px);

              .login-nickname {
                width: 100%;
                height: 100%;
                @include clearInput;
                color: black;
                font-size: pxTorem(18px);
                line-height: pxTorem(34px);

                &::placeholder {
                  color: #808081;
                  font-style: italic;
                }
              }
            }
          }
          .login-nickname-tip {
            font-size: pxTorem(14px);
            color: #a0a0a0;
          }
          .yostar-login-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: pxTorem(25px);

            .login-in-button,
            .cancel-button {
              width: pxTorem(160px);
              height: pxTorem(25px);
              background: #0062d0;
              color: white;
              font-size: pxTorem(18px);
              line-height: pxTorem(25px);
              text-align: center;
              font-weight: bold;
              cursor: pointer;
              font-family: "Noto Sans KR", sans-serif;
            }
            .cancel-button {
              background: black;
            }
          }
        }
      }
    }
  }
}
</style>
